import React from 'react';
import { Mail } from 'lucide-react';

const Highlight = ({ label, value, valueClass = 'text-lg' }) => (
  <div className="bg-gradient-to-br from-cyan-50 to-teal-50 p-4 rounded-xl border border-cyan-100">
    <div className="text-sm text-cyan-700 font-semibold mb-1">{label}</div>
    <div className={`${valueClass} font-bold text-gray-900`}>{value}</div>
  </div>
);

export const LeaderCard = ({ leader }) => (
  <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow">
    <div className="relative h-80">
      <img src={leader.image} alt={leader.name} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
      <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg">
        <h4 className="text-2xl font-bold text-gray-900 mb-1">{leader.name}</h4>
        <p className="text-cyan-600 font-semibold">{leader.designation}</p>
      </div>
    </div>

    <div className="p-8 space-y-6">
      <p className="text-gray-700 leading-relaxed">{leader.description}</p>

      {leader.email && (
        <div className="flex items-center gap-2 text-cyan-600">
          <Mail className="w-4 h-4" />
          <a href={`mailto:${leader.email}`} className="hover:text-cyan-700 font-medium">
            {leader.email}
          </a>
        </div>
      )}

      <div className="grid grid-cols-2 gap-4">
        <Highlight label="Experience" value={leader.experience} />
        <Highlight label="Expertise" value={leader.specialization} valueClass="text-sm" />
      </div>
    </div>
  </div>
);

export default LeaderCard;
